// extracted by mini-css-extract-plugin
module.exports = {"mainUiBlock":"_2-32h","tooltipContainerWrapper":"_3BPgJ"};